import { createRoute } from '@tanstack/react-router';
import { IconCash } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { readFinanceAccess } from '../finance/access';
import { Payments } from './Payments';
import { payOutApiRoute, payRecvApiRoute } from './apiRoute';
import { TX } from './data';

/** Luồng N · Thanh toán (sổ thu chi): sau quyền `money` — menu chỉ hiện cho người có quyền. */
const payments: EzyModule = {
  nav: typeof location !== 'undefined' && readFinanceAccess(location.search).money
    ? { key: 'payments', label: 'Thanh toán', icon: IconCash, items: [{ key: 'payments', label: 'Thanh toán', to: '/ezy/payments' }] }
    : undefined,
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/payments', component: Payments })],
  api: { payRecv: payRecvApiRoute, payOut: payOutApiRoute },
  fixtures: (register) => {
    register('payRecv', TX.filter((x) => x.tab !== 'chi'));
    register('payOut', TX.filter((x) => x.tab === 'chi'));
  },
};
export default payments;
